// extracted by mini-css-extract-plugin
export default {"title":"Dashboard_title__hG5xT","wrapper":"Dashboard_wrapper__2b6VF","btn":"Dashboard_btn__p97tI","selectedItem":"Dashboard_selectedItem__F5Xpx"};